/**
 * Persist Pause for Q&A / Resume session so attendance stops while paused.
 */

import { livekitAuthService as authService } from "../utils/authService";

export async function setSessionQaPaused(
  sessionId: string | number,
  paused: boolean,
  options?: { endTraining?: boolean },
): Promise<void> {
  await authService.post(`/session/sessions/${sessionId}/qa-pause/`, {
    paused,
    end_training: Boolean(options?.endTraining),
  });
}
